import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function whitespace(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value === null || control.value === undefined) {
      return null;
    }
    const isWhitespace = control.value !== '' && control.value.trim().length === 0;
    const isValid = !isWhitespace;

    return isValid ? null : { whitespace: true };
  };
}
